import script from "./details.vue?vue&type=script&setup=true&lang=js"
export * from "./details.vue?vue&type=script&setup=true&lang=js"

import "./details.vue?vue&type=style&index=0&id=cbfd35ae&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbfd35ae"]])

export default __exports__